import { StyleSheet, Text, type TextProps } from "react-native";

import type { UiTheme } from "../theme";

// L'etichetta che sta SOPRA un campo, in un posto solo.
//
// Era scritta a mano in cinque punti — `LoginScreen`, `ForgotPasswordScreen`,
// `accountEditorStyles`, `WelcomeForm`, `SignInForm` — e le cinque copie
// divergevano già: quattro a `base` e una a `sm`, `letterSpacing` in due su
// cinque. Un dettaglio che cambia su uno schermo solo è esattamente il modo in
// cui una porta smette di sembrare la stessa porta.
//
// `base` e non `sm`, deciso quando la porta d'accesso è stata alzata su
// entrambi i mount: dove si scrive una password o un'email la leggibilità batte
// la densità, ed è la lettura che ogni sessione apre.
//
// ⛔ È una FOGLIA e non possiede il layout: margini e spaziatura restano del
// chiamante via `style` (merge last), perché chi impagina sa se il campo vive
// in una colonna con `gap` o in una card che spinge dall'alto.
//
// ⚠️ Non espone una misura: `base` è cablata. Un sesto fratello resta a mano
// apposta, `CoachSettingsScreen.formLabel`, che è a `sm` perché è una sotto-form
// di impostazioni. Se un giorno anche quello deve entrare qui, la mossa è una
// prop di misura, non una seconda copia.
export type FieldLabelProps = Omit<TextProps, "style"> & {
  theme: UiTheme;
  children: React.ReactNode;
  /** Layout-only override (margini). Merged last; la tipografia resta. */
  style?: TextProps["style"];
};

export function FieldLabel({ theme, children, style, ...rest }: FieldLabelProps) {
  const styles = makeStyles(theme);
  return (
    <Text style={[styles.label, style]} {...rest}>
      {children}
    </Text>
  );
}

function makeStyles(theme: UiTheme) {
  const { palette: p, typography: ty } = theme;
  return StyleSheet.create({
    label: {
      color: p.ink2,
      fontSize: ty.sizes.base,
      fontWeight: "600",
      letterSpacing: 0.3,
    },
  });
}
